import PropTypes from "prop-types";
import React from "react";

import { appendClassName } from "@elastic/react-search-ui-views/lib/view-helpers";

function FilteredPagingInfo({
  className,
  end,
  searchTerm,
  start,
  totalResults,
  filters,
  facets,
  ...rest
}) {
  return (
    <div className={appendClassName("sui-paging-info", className)} {...rest}>
      Showing{" "}
      <strong>
        {start} - {end}
      </strong>{" "}
      out of <strong>{totalResults}</strong>
      {searchTerm && (
        <>
          {" "}
          for: <em>{searchTerm}</em>
        </>
      )}
    </div>
  );
  // TODO print filter info on the paging snippet
  // but how do we get the filter labels?
}

FilteredPagingInfo.propTypes = {
  end: PropTypes.number.isRequired,
  searchTerm: PropTypes.string.isRequired,
  start: PropTypes.number.isRequired,
  totalResults: PropTypes.number.isRequired,
  className: PropTypes.string
};

export default FilteredPagingInfo;